import { IonCol } from '@ionic/react';
import React from 'react';
import { AqiCard } from '../../components/AqiCard';
import { useSettings } from '../../contexts/SettingsContext';
import { getAqText } from '../../shared/aqi';
import { BaseSection } from '../BaseSection';

export const CurrentAQSection: React.FC = () => {
  const { aqiStandard } = useSettings();
  return (
    aqiStandard && (
      <BaseSection title={`Current ${getAqText(aqiStandard.aqiStandardId)}`}>
        <IonCol>
          <AqiCard />
        </IonCol>
      </BaseSection>
    )
  );
};
